
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4KbgO", function(module, exports) {

$parcel$export(module.exports, "AISummaryFooter", () => $3b9f226590522b72$export$409c83e49353f3fb);
/* AISummaryFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $dpPtd = parcelRequire("dpPtd");

var $inPa6 = parcelRequire("inPa6");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $9wGTI = parcelRequire("9wGTI");

var $63blV = parcelRequire("63blV");

var $aijNR = parcelRequire("aijNR");

var $8qpb0 = parcelRequire("8qpb0");

var $6bd6t = parcelRequire("6bd6t");

var $4UmYg = parcelRequire("4UmYg");
const $3b9f226590522b72$var$i18n = (0, $2nPZH.defineMessages)({
    aiMessage: {
        id: "quick-summary.ai.message",
        defaultMessage: "Generated by AI. Content quality may vary."
    }
});
const $3b9f226590522b72$var$copyButtonStyles = (0, $ecnYn.xcss)({
    height: '24px',
    listStyle: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $3b9f226590522b72$var$FooterWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18zrpxbi _1rjc1b66 _x3dozgxb _ekv6b0ay _43dspf9b _oxk4xz2p _1fer346o",
            __cmplp.className
        ])
    });
});
const $3b9f226590522b72$var$stackStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.050',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $3b9f226590522b72$var$copyButtonULStyles = (0, $ecnYn.xcss)({
    margin: 'space.0',
    padding: 'space.0'
});
const $3b9f226590522b72$var$aiMessageStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $3b9f226590522b72$export$409c83e49353f3fb = ({ analyticsProperties: analyticsProperties, contentId: contentId, contentType: contentType, summaryText: summaryText, error: error, showBetaLozenge: showBetaLozenge, refreshHandler: refreshHandler, shouldHighlightRefresh: shouldHighlightRefresh, isHidden: isHidden = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onLearnMoreClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LearnWhyLink`,
                attributes: {
                    contentId: contentId,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    if (isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.200",
        xcss: $3b9f226590522b72$var$stackStyles
    }, !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "ai-summary-footer",
        ...!(0, $9wGTI.fg)('p2m-hover-card-updates') && {
            paddingInline: 'space.200'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, (0, $9wGTI.fg)('p2m-hover-card-updates') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3b9f226590522b72$var$aiMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3b9f226590522b72$var$i18n.aiMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6bd6t.SmartsFeedbackComponent), {
        analyticsProperties: analyticsProperties,
        contentId: contentId
    }), !!summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "ul",
        xcss: $3b9f226590522b72$var$copyButtonULStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: $3b9f226590522b72$var$copyButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8qpb0.CopySummaryButton), {
        analyticsProperties: analyticsProperties,
        contentId: contentId,
        summaryText: summaryText
    }))), refreshHandler && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4UmYg.RefreshSummaryButton), {
        analyticsProperties: analyticsProperties,
        contentId: contentId,
        onRefreshClicked: refreshHandler,
        shouldHighlightRefresh: shouldHighlightRefresh
    })), contentType === 'whiteboard' && !!summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aijNR.CreatePageButton), {
        summaryText: summaryText
    }))), !(0, $9wGTI.fg)('p2m-hover-card-updates') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3b9f226590522b72$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $63blV.AIAttributionFooter), {
        showBetaLozenge: showBetaLozenge,
        onLinkClick: onLearnMoreClicked
    }))));
};

});
parcelRegister("63blV", function(module, exports) {

$parcel$export(module.exports, "AIAttributionFooter", () => $75f4c452dbf67a05$export$c7fc4bd65402b494);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $3Mg7y = parcelRequire("3Mg7y");

var $b9sgO = parcelRequire("b9sgO");

var $aIk0I = parcelRequire("aIk0I");

var $fpGTa = parcelRequire("fpGTa");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $4JDbp = parcelRequire("4JDbp");

var $ezYWs = parcelRequire("ezYWs");

var $jjneR = parcelRequire("jjneR");
const $75f4c452dbf67a05$var$footerContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $75f4c452dbf67a05$var$footerDisclaimerStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050'
});
const $75f4c452dbf67a05$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.selected',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});
const $75f4c452dbf67a05$export$c7fc4bd65402b494 = ({ onLinkClick: onLinkClick, showBetaLozenge: showBetaLozenge })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [footerWidth, setFooterWidth] = (0, $gwFzn.useState)(0);
    const betaLozengeText = formatMessage((0, $jjneR.i18n).betaLozenge);
    const attributionMessage = ()=>{
        if (footerWidth >= (0, $ezYWs.LARGE_BREAKPOINT)) return formatMessage((0, $jjneR.i18n).attributionFooterAttributionLabelLarge);
        else if (footerWidth >= (0, $ezYWs.MEDIUM_BREAKPOINT) && footerWidth < (0, $ezYWs.LARGE_BREAKPOINT)) return formatMessage((0, $jjneR.i18n).attributionFooterAttributionLabelMedium);
        else return null;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $75f4c452dbf67a05$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setFooterWidth
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                xcss: $75f4c452dbf67a05$var$footerDisclaimerStyles,
                space: "space.050",
                children: [
                    showBetaLozenge && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                        children: betaLozengeText
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9sgO))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #626F86)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
                        xcss: $75f4c452dbf67a05$var$linkStyles,
                        href: (0, $ezYWs.LINK_HREF),
                        target: "_blank",
                        onClick: onLinkClick,
                        children: footerWidth >= (0, $ezYWs.LARGE_BREAKPOINT) ? formatMessage((0, $jjneR.i18n).attributionFooterDisclaimerLarge) : formatMessage((0, $jjneR.i18n).attributionFooterDisclaimer)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: attributionMessage()
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                        color: "var(--ds-icon, #44546F)",
                        label: formatMessage((0, $jjneR.i18n).atlassianIntelligenceIconAlt)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("b9sgO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4e114f01fe535a5a32bd9e3d0b8249d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81e676dac12cc79d$var$_react = $81e676dac12cc79d$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $81e676dac12cc79d$var$_baseNew = $81e676dac12cc79d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $81e676dac12cc79d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81e676dac12cc79d$var$InformationIcon = (props)=>/*#__PURE__*/ $81e676dac12cc79d$var$_react.default.createElement($81e676dac12cc79d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$81e676dac12cc79d$var$InformationIcon.displayName = 'InformationIcon';
var $81e676dac12cc79d$var$_default = module.exports.default = $81e676dac12cc79d$var$InformationIcon;

});

parcelRegister("aIk0I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ed714aba6e968ef3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $3YksS = parcelRequire("3YksS");

var $8bTbx = parcelRequire("8bTbx");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $ed714aba6e968ef3$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>(0, $dh538.fg)('platform_dst_lozenge_fg') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3YksS.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8bTbx.default), {
        ...props
    }));
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$ed714aba6e968ef3$var$Lozenge.displayName = 'Lozenge';
var $ed714aba6e968ef3$export$2e2bcd8739ae039 = $ed714aba6e968ef3$var$Lozenge;

});
parcelRegister("3YksS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d54feba2a694c08a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
const $d54feba2a694c08a$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syaz1gjq",
    'text.subtle.inprogress': "_syaze0os",
    'text.subtle.moved': "_syazwx40",
    'text.subtle.new': "_syazzjem",
    'text.subtle.removed': "_syaz1tmw",
    'text.subtle.success': "_syazy73q"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
const $d54feba2a694c08a$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
const $d54feba2a694c08a$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
}; /**
    * TODO: We should be using our bounded `cssMap` here, but most of
    * these styles from the visual refresh are not in the Design System.
    */ 
const $d54feba2a694c08a$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
const $d54feba2a694c08a$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $d54feba2a694c08a$var$Lozenge = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $gwFzn.useMemo)(()=>$d54feba2a694c08a$var$appearanceTypes.includes(appearance) ? appearance : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $d54feba2a694c08a$var$stylesNew.container,
            $d54feba2a694c08a$var$stylesNew[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && !(0, $dh538.fg)('visual-refresh_drop_5') && $d54feba2a694c08a$var$stylesNew[`border.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $d54feba2a694c08a$var$stylesNew[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $d54feba2a694c08a$var$stylesNew.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $35pXk.default)([
                $d54feba2a694c08a$var$stylesNew.text,
                (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $d54feba2a694c08a$var$stylesNew.customLetterspacing,
                $d54feba2a694c08a$var$stylesNew[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "span",
        backgroundColor: $d54feba2a694c08a$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $d54feba2a694c08a$var$stylesOld.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $35pXk.default)([
                $d54feba2a694c08a$var$stylesOldUnbounded.text,
                (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $d54feba2a694c08a$var$stylesOldUnbounded.customLetterspacing,
                $d54feba2a694c08a$var$stylesOld[`text.${appearanceStyle}.${appearanceType}`]
            ]),
            children: children
        })
    });
});
$d54feba2a694c08a$var$Lozenge.displayName = 'Lozenge';
var $d54feba2a694c08a$export$2e2bcd8739ae039 = $d54feba2a694c08a$var$Lozenge;

});

parcelRegister("8bTbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a62df7e22140fc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $c5a62df7e22140fc$var$baseStylesOld = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $c5a62df7e22140fc$var$styles = {
    container: (0, $3jLHL.css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        position: 'static',
        blockSize: 'min-content',
        borderRadius: '3px',
        overflow: 'hidden',
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $3jLHL.css)({
                backgroundColor: '#DDDEE1'
            }),
            inprogress: (0, $3jLHL.css)({
                backgroundColor: '#8FB8F6'
            }),
            moved: (0, $3jLHL.css)({
                backgroundColor: '#F9C84E'
            }),
            new: (0, $3jLHL.css)({
                backgroundColor: '#D8A0F7'
            }),
            removed: (0, $3jLHL.css)({
                backgroundColor: '#FD9891'
            }),
            success: (0, $3jLHL.css)({
                backgroundColor: '#B3DF72'
            })
        },
        subtle: {
            default: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $3jLHL.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $3jLHL.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: (0, $3jLHL.css)({
                border: `1px solid #669DF1`
            }),
            moved: (0, $3jLHL.css)({
                border: `1px solid #FCA700`
            }),
            new: (0, $3jLHL.css)({
                border: `1px solid #C97CF4`
            }),
            removed: (0, $3jLHL.css)({
                border: `1px solid #F87168`
            }),
            success: (0, $3jLHL.css)({
                border: `1px solid #94C748`
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $3jLHL.css)({
                outline: `1px solid #B7B9BE`
            }),
            inprogress: (0, $3jLHL.css)({
                outline: `1px solid #669DF1`
            }),
            moved: (0, $3jLHL.css)({
                outline: `1px solid #FCA700`
            }),
            new: (0, $3jLHL.css)({
                outline: `1px solid #C97CF4`
            }),
            removed: (0, $3jLHL.css)({
                outline: `1px solid #F87168`
            }),
            success: (0, $3jLHL.css)({
                outline: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: (0, $3jLHL.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $3jLHL.css)({
            color: '#292A2E'
        })
    }
};
const $c5a62df7e22140fc$var$textStyles = (0, $3jLHL.css)({
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
});
const $c5a62df7e22140fc$var$customLetterspacingStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: 0.165
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $c5a62df7e22140fc$var$Lozenge = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $c5a62df7e22140fc$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $c5a62df7e22140fc$var$styles.container,
            $c5a62df7e22140fc$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $dh538.fg)('visual-refresh_drop_5') && $c5a62df7e22140fc$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $c5a62df7e22140fc$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $dh538.fg)('visual-refresh_drop_5') && $c5a62df7e22140fc$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            $c5a62df7e22140fc$var$textStyles,
            (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $c5a62df7e22140fc$var$customLetterspacingStyles,
            $c5a62df7e22140fc$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $c5a62df7e22140fc$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        as: "span",
        backgroundColor: $c5a62df7e22140fc$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $c5a62df7e22140fc$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            $c5a62df7e22140fc$var$textStyles,
            (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $c5a62df7e22140fc$var$customLetterspacingStyles,
            $c5a62df7e22140fc$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$c5a62df7e22140fc$var$Lozenge.displayName = 'Lozenge';
var $c5a62df7e22140fc$export$2e2bcd8739ae039 = $c5a62df7e22140fc$var$Lozenge;
const $c5a62df7e22140fc$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $c5a62df7e22140fc$var$textColorsOld = {
    bold: {
        default: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $3jLHL.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $3jLHL.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $3jLHL.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $3jLHL.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $3jLHL.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $3jLHL.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $3jLHL.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $3jLHL.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};

});


parcelRegister("fpGTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b8a9bd852ba155$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $5Uzw3 = parcelRequire("5Uzw3");

var $gxtzC = parcelRequire("gxtzC");

var $6i41U = parcelRequire("6i41U");

var $ee7An = parcelRequire("ee7An");

var $c0qxy = parcelRequire("c0qxy");

var $90YwQ = parcelRequire("90YwQ");

var $6F6hl = parcelRequire("6F6hl");

var $avd77 = parcelRequire("avd77");

var $ecnYn = parcelRequire("ecnYn");
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $03b8a9bd852ba155$var$focusRingStyles = (0, $3jLHL.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $avd77.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $avd77.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $avd77.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $03b8a9bd852ba155$var$baseStyles = (0, $3jLHL.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
const $03b8a9bd852ba155$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $03b8a9bd852ba155$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $03b8a9bd852ba155$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $03b8a9bd852ba155$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $gwFzn.useContext)((0, $90YwQ.default));
    const handleClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $c0qxy.useId)();
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    const RouterLink = (0, $6i41U.default)();
    const isExternal = typeof href === 'string' && $03b8a9bd852ba155$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $03b8a9bd852ba155$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $5Uzw3.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $3jLHL.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $03b8a9bd852ba155$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $03b8a9bd852ba155$var$baseStyles,
            $03b8a9bd852ba155$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avd77.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avd77.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avd77.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avd77.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avd77.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avd77.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avd77.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avd77.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6F6hl.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $03b8a9bd852ba155$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $03b8a9bd852ba155$var$Anchor = /*#__PURE__*/ (0, $gwFzn.forwardRef)($03b8a9bd852ba155$var$AnchorNoRef);
var $03b8a9bd852ba155$export$2e2bcd8739ae039 = $03b8a9bd852ba155$var$Anchor;

});

parcelRegister("4JDbp", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $b400565b9de87bc3$export$b2ad68b9bc407b80);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $i7RGj = parcelRequire("i7RGj");
const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});
parcelRegister("i7RGj", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $0e043a05e9b77ebf$export$ff983d2a2b6112ea);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lfOVK = parcelRequire("lfOVK");
const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $lfOVK.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("lfOVK", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $72cd6c8cfec5859a$export$2f62ee6831462844);

var $gwFzn = parcelRequire("gwFzn");
function $72cd6c8cfec5859a$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("ezYWs", function(module, exports) {

$parcel$export(module.exports, "LARGE_BREAKPOINT", () => $010c748f3ca601da$export$ba58b4d4ecb9b338);
$parcel$export(module.exports, "MEDIUM_BREAKPOINT", () => $010c748f3ca601da$export$3a75af9c02826b93);
$parcel$export(module.exports, "LINK_HREF", () => $010c748f3ca601da$export$e2297811c4a04978);
const $010c748f3ca601da$export$ba58b4d4ecb9b338 = 600;
const $010c748f3ca601da$export$3a75af9c02826b93 = 320;
const $010c748f3ca601da$export$e2297811c4a04978 = 'https://www.atlassian.com/trust/atlassian-intelligence';

});

parcelRegister("jjneR", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $d509bd528a228fac$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $d509bd528a228fac$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    attributionFooterDisclaimerLarge: {
        id: "attribution-footer.disclaimer.large.text",
        defaultMessage: "Content is based on your permissions and its quality may vary"
    },
    attributionFooterDisclaimer: {
        id: "attribution-footer.disclaimer.text",
        defaultMessage: "Content quality may vary"
    },
    attributionFooterAttributionLabelLarge: {
        id: "attribution-footer.attribution-label.large.text",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    attributionFooterAttributionLabelMedium: {
        id: "attribution-footer.attribution-label.medium.text",
        defaultMessage: "Powered by AI"
    },
    atlassianIntelligenceIconAlt: {
        id: "attribution-footer.atlassian-intelligence-icon.alt-text",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLozenge: {
        id: "attribution-footer.beta-lozenge",
        defaultMessage: "Beta"
    }
});

});


parcelRegister("aijNR", function(module, exports) {

$parcel$export(module.exports, "CreatePageButton", () => $33eb09d5b0da5a27$export$305e51f590235bd4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $iEKnc = parcelRequire("iEKnc");

var $ccHMk = parcelRequire("ccHMk");

var $dpPtd = parcelRequire("dpPtd");

var $fYQcF = parcelRequire("fYQcF");

var $dIouf = parcelRequire("dIouf");

var $dPJCf = parcelRequire("dPJCf");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $1NBp8 = parcelRequire("1NBp8");

var $5WfNS = parcelRequire("5WfNS");

var $g9HcH = parcelRequire("g9HcH");
const $33eb09d5b0da5a27$var$i18n = (0, $2nPZH.defineMessages)({
    createPageButton: {
        id: "quick-summary.create-page-button.button-text",
        defaultMessage: "Create page"
    },
    errorFlagTitle: {
        id: "quick-summary.create-page-button.error-flag-title",
        defaultMessage: "We couldn\u2019t create the page"
    },
    errorFlagBody: {
        id: "quick-summary.create-page-button.error-flag-body",
        defaultMessage: "There was an error creating the summary page. Reload and try again."
    },
    titleWithSummaryHyphen: {
        id: "quick-summary.create-page-button.title-suffix",
        defaultMessage: "Summary of {contentTitle}"
    }
});
const $33eb09d5b0da5a27$var$CreatePageButtonComponent = ({ summaryText: summaryText })=>{
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { contentId: contentId, spaceKey: spaceKey, contentTitle: contentTitle } = (0, $5WfNS.useCreatePageButtonContext)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [createPage, { loading: loading, error: error }] = (0, $g9HcH.useCreatePage)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    if (!spaceKey || !contentId || !contentTitle) return null;
    const handleCreatePage = async (parentPageId = contentId, destinationSpaceKey = spaceKey)=>{
        trackAIResultAction('createPageModalConfirmButtonClicked');
        experienceTracker.start({
            name: (0, $irVI7.QUICK_SUMMARY_TO_PAGE_EXPERIENCE)
        });
        try {
            const pageTitle = formatMessage($33eb09d5b0da5a27$var$i18n.titleWithSummaryHyphen, {
                contentTitle: contentTitle
            });
            const result = await createPage({
                parentId: parentPageId,
                spaceKey: destinationSpaceKey,
                pageTitle: pageTitle,
                content: summaryText
            });
            const draftUrl = (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: destinationSpaceKey,
                contentId: result.data.newPage.page.id
            });
            experienceTracker.succeed({
                name: (0, $irVI7.QUICK_SUMMARY_TO_PAGE_EXPERIENCE)
            });
            push(draftUrl);
        } catch (err) {
            experienceTracker.fail({
                name: (0, $irVI7.QUICK_SUMMARY_TO_PAGE_EXPERIENCE),
                error: err
            });
            showFlag({
                title: formatMessage($33eb09d5b0da5a27$var$i18n.errorFlagTitle),
                description: formatMessage($33eb09d5b0da5a27$var$i18n.errorFlagBody),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                }),
                isAutoDismiss: true
            });
        }
    };
    const handleCreatePageButtonClick = ()=>{
        handleCreatePage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleCreatePageButtonClick,
        isLoading: loading
    }, formatMessage($33eb09d5b0da5a27$var$i18n.createPageButton)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};
const $33eb09d5b0da5a27$export$305e51f590235bd4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($33eb09d5b0da5a27$var$CreatePageButtonComponent, props));
};

});
parcelRegister("g9HcH", function(module, exports) {

$parcel$export(module.exports, "useCreatePage", () => $c38c3f2e8f835bbb$export$42e8c1f8e93aa628);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $5x0y1 = parcelRequire("5x0y1");
var $2FFuS = parcelRequire("2FFuS");

var $h9yJL = parcelRequire("h9yJL");

var $aRZzN = parcelRequire("aRZzN");

var $ODlve = parcelRequire("ODlve");
const $c38c3f2e8f835bbb$var$useCreatePageCreatePageMutation = (0, $d2LG0.default)`mutation useCreatePageCreatePageMutation($spaceKey:ID!$pageTitle:String!$parentId:ID!$pageContent:String!){newPage(input:{space:{key:$spaceKey}page:{title:$pageTitle status:DRAFT parentId:$parentId body:{representation:ATLAS_DOC_FORMAT value:$pageContent}}}){page{id}}}`;
const $c38c3f2e8f835bbb$var$i18n = (0, $2nPZH.defineMessages)({
    generatedFromFooter: {
        id: "quick-summary.create-page-modal.generated-from-footer",
        defaultMessage: "Generated from:"
    }
});
const $c38c3f2e8f835bbb$export$42e8c1f8e93aa628 = ()=>{
    const [createPresentationMutation, mutationResults] = (0, $diswb.useMutation)($c38c3f2e8f835bbb$var$useCreatePageCreatePageMutation);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const createPage = (0, $gwFzn.useCallback)(({ pageTitle: pageTitle, spaceKey: spaceKey, parentId: parentId, content: content })=>{
        const markdown = new (0, $aRZzN.MarkdownTransformer)((0, $ODlve.defaultSchema)).parse(content);
        const adf = new (0, $h9yJL.JSONTransformer)().encode(markdown);
        const spacerParagraph = (0, $2FFuS.paragraph)();
        const linkParagraph = (0, $2FFuS.paragraph)(formatMessage($c38c3f2e8f835bbb$var$i18n.generatedFromFooter), // eslint-disable-next-line no-restricted-syntax
        (0, $5x0y1.inlineCard)({
            url: window.location.href
        }));
        adf.content.push(spacerParagraph, linkParagraph);
        return createPresentationMutation({
            variables: {
                spaceKey: spaceKey,
                parentId: parentId,
                pageTitle: pageTitle,
                pageContent: JSON.stringify(adf)
            }
        });
    }, [
        createPresentationMutation,
        formatMessage
    ]);
    return [
        createPage,
        mutationResults
    ];
};

});
parcelRegister("5x0y1", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $548cbc934d83dd4c$export$cbf8224b64e0d942);
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });

});

parcelRegister("2FFuS", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $a4fc62108e90d067$export$9c206ddddb32a9b);

var $enilC = parcelRequire("enilC");
const $a4fc62108e90d067$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $enilC.createTextNodes)(content)
    });

});
parcelRegister("enilC", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $b397a3d9dc60a40a$export$3a269a5941b62f04);

var $aoDcQ = parcelRequire("aoDcQ");
function $b397a3d9dc60a40a$export$3a269a5941b62f04(nodes) {
    return nodes.map($b397a3d9dc60a40a$export$72b9432ea0656b50);
}
function $b397a3d9dc60a40a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $aoDcQ.text)(str) : str;
}

});
parcelRegister("aoDcQ", function(module, exports) {

$parcel$export(module.exports, "text", () => $cb8b1b1eb7a280a9$export$6f093cfa640b7166);
const $cb8b1b1eb7a280a9$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("h9yJL", function(module, exports) {

$parcel$export(module.exports, "JSONTransformer", () => $f8f7a748914a9c23$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $atveb = parcelRequire("atveb");

var $ddar1 = parcelRequire("ddar1");
var $4HChC = parcelRequire("4HChC");
var $hJ7IY = parcelRequire("hJ7IY");
var $ifQgG = parcelRequire("ifQgG");
var $7KPyX = parcelRequire("7KPyX");
var $dQPhK = parcelRequire("dQPhK");
var $jGJid = parcelRequire("jGJid");
var $ilnFA = parcelRequire("ilnFA");
var $65GP4 = parcelRequire("65GP4");

var $ODlve = parcelRequire("ODlve");

var $hdkEr = parcelRequire("hdkEr");

var $cWvTp = parcelRequire("cWvTp");
var $f8f7a748914a9c23$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $f8f7a748914a9c23$var$isType = (type)=>(node)=>node.type.name === type;
const $f8f7a748914a9c23$var$isCodeBlock = $f8f7a748914a9c23$var$isType('codeBlock');
const $f8f7a748914a9c23$var$isMediaNode = $f8f7a748914a9c23$var$isType('media');
const $f8f7a748914a9c23$var$isMediaInline = $f8f7a748914a9c23$var$isType('mediaInline');
const $f8f7a748914a9c23$var$isMediaSingleNode = $f8f7a748914a9c23$var$isType('mediaSingle');
const $f8f7a748914a9c23$var$isMentionNode = $f8f7a748914a9c23$var$isType('mention');
const $f8f7a748914a9c23$var$isParagraph = $f8f7a748914a9c23$var$isType('paragraph');
const $f8f7a748914a9c23$var$isHeading = $f8f7a748914a9c23$var$isType('heading');
const $f8f7a748914a9c23$var$isTable = $f8f7a748914a9c23$var$isType('table');
const $f8f7a748914a9c23$var$isTableCell = $f8f7a748914a9c23$var$isType('tableCell');
const $f8f7a748914a9c23$var$isTableHeader = $f8f7a748914a9c23$var$isType('tableHeader');
const $f8f7a748914a9c23$var$isLinkMark = $f8f7a748914a9c23$var$isType('link');
const $f8f7a748914a9c23$var$isUnsupportedMark = $f8f7a748914a9c23$var$isType('unsupportedMark');
const $f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark = $f8f7a748914a9c23$var$isType('unsupportedNodeAttribute');
const $f8f7a748914a9c23$var$isExpand = $f8f7a748914a9c23$var$isType('expand');
const $f8f7a748914a9c23$var$isNestedExpand = $f8f7a748914a9c23$var$isType('nestedExpand');
const $f8f7a748914a9c23$var$isUnsupportedNode = (node)=>$f8f7a748914a9c23$var$isType('unsupportedBlock')(node) || $f8f7a748914a9c23$var$isType('unsupportedInline')(node);
const $f8f7a748914a9c23$var$isDataConsumer = $f8f7a748914a9c23$var$isType('dataConsumer');
const $f8f7a748914a9c23$var$isFragmentMark = $f8f7a748914a9c23$var$isType('fragment');
const $f8f7a748914a9c23$var$isHardBreak = $f8f7a748914a9c23$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f8f7a748914a9c23$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $f8f7a748914a9c23$var$filterNull(current);
    }
    return output;
};
const $f8f7a748914a9c23$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $f8f7a748914a9c23$var$emptyDoc = $f8f7a748914a9c23$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $f8f7a748914a9c23$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($f8f7a748914a9c23$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($f8f7a748914a9c23$var$isMediaNode(node)) obj.attrs = (0, $jGJid.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMediaSingleNode(node)) obj.attrs = (0, $dQPhK.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMediaInline(node)) obj.attrs = (0, $jGJid.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMentionNode(node)) obj.attrs = (0, $ilnFA.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isCodeBlock(node)) obj.attrs = (0, $ddar1.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTable(node)) obj.attrs = (0, $65GP4.tableToJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTableCell(node)) obj.attrs = (0, $65GP4.toJSONTableCell)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTableHeader(node)) obj.attrs = (0, $65GP4.toJSONTableHeader)(node).attrs;
    else if ($f8f7a748914a9c23$var$isExpand(node) || $f8f7a748914a9c23$var$isNestedExpand(node)) obj.attrs = (0, $hJ7IY.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $f8f7a748914a9c23$var$filterNull(obj.attrs);
    if ($f8f7a748914a9c23$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($f8f7a748914a9c23$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($f8f7a748914a9c23$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($f8f7a748914a9c23$var$toJSON(child, mentionMap));
    });
    if ($f8f7a748914a9c23$var$isParagraph(node) || $f8f7a748914a9c23$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($f8f7a748914a9c23$var$isUnsupportedMark(mark)) return $f8f7a748914a9c23$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($f8f7a748914a9c23$var$isLinkMark(mark)) return (0, $7KPyX.toJSON)(mark);
            else if ($f8f7a748914a9c23$var$isDataConsumer(mark)) {
                const serialised = (0, $4HChC.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($f8f7a748914a9c23$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $ifQgG.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$f8f7a748914a9c23$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $f8f7a748914a9c23$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $hdkEr.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $f8f7a748914a9c23$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $f8f7a748914a9c23$export$98cb1d9308d0944d {
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $cWvTp.sanitizeNode)($f8f7a748914a9c23$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(content, $f8f7a748914a9c23$var$emptyDoc.content)) return $f8f7a748914a9c23$var$createDocFromContent([]);
        return $f8f7a748914a9c23$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $ODlve.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($f8f7a748914a9c23$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $cWvTp.sanitizeNode)($f8f7a748914a9c23$var$toJSON(node, this.mentionMap));
    }
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $ODlve.defaultSchema), mentionMap){
        this.schema = void 0;
        this.mentionMap = void 0;
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
}

});
parcelRegister("hdkEr", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $08eccc3aac6e9e51$export$28e4e3c024cce988);
const $08eccc3aac6e9e51$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $08eccc3aac6e9e51$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $08eccc3aac6e9e51$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $08eccc3aac6e9e51$var$defaultAllowOverrideBehaviour;
        default:
            return $08eccc3aac6e9e51$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("cWvTp", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $f8993b2ce626873e$export$48b382180baf8e88);

var $dDZcC = parcelRequire("dDZcC");

var $6jPem = parcelRequire("6jPem");

var $dh538 = parcelRequire("dh538");

var $h9h40 = parcelRequire("h9h40");
const $f8993b2ce626873e$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $f8993b2ce626873e$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $h9h40.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($f8993b2ce626873e$var$hasNestedTable(node) && (0, $dh538.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($f8993b2ce626873e$var$hasNestedTable(node) && (0, $dh538.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $h9h40.removeNonAnnotationMarks),
        mention: (0, $h9h40.removeNonAnnotationMarks),
        date: (0, $h9h40.removeNonAnnotationMarks),
        hardBreak: (0, $h9h40.removeMarks),
        inlineCard: (0, $h9h40.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("dDZcC", function(module, exports) {

$parcel$export(module.exports, "isNestedTableExtension", () => $af3cc9663dee118d$export$f45e7335ec874bfe);
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $af3cc9663dee118d$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $af3cc9663dee118d$export$8a334a7d9fe120ec);

var $6jPem = parcelRequire("6jPem");

var $9gh1o = parcelRequire("9gh1o");

var $hEWef = parcelRequire("hEWef");
const $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $af3cc9663dee118d$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY;
const $af3cc9663dee118d$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $hEWef.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
function $af3cc9663dee118d$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $af3cc9663dee118d$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $af3cc9663dee118d$export$18544d0b5f43e4a1 = (adf, options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        extension: (node, parent)=>{
            if ($af3cc9663dee118d$export$f45e7335ec874bfe(node)) {
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $af3cc9663dee118d$var$isInsideBodiedExtension(parent)) return undefined;
                isTransformed = true;
                return $af3cc9663dee118d$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $af3cc9663dee118d$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $9gh1o.extension)({
                    extensionType: $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $hEWef.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("9gh1o", function(module, exports) {

$parcel$export(module.exports, "extension", () => $0b52ddd0ebfb8ca2$export$1b45514b112dd749);
const $0b52ddd0ebfb8ca2$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("hEWef", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $efc09fde1d3b7fcb$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $efc09fde1d3b7fcb$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("h9h40", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $36b0fc3bb7ba2bf8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $36b0fc3bb7ba2bf8$export$8cae9126fc577085);
function $36b0fc3bb7ba2bf8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $36b0fc3bb7ba2bf8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("aRZzN", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $70b3fb435fbd97a9$export$267fd7ead7cc4561);

var $ODlve = parcelRequire("ODlve");

var $7KLhS = parcelRequire("7KLhS");

var $8iNK1 = parcelRequire("8iNK1");

var $4xvuZ = parcelRequire("4xvuZ");

var $ldaVn = parcelRequire("ldaVn");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70b3fb435fbd97a9$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $70b3fb435fbd97a9$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $70b3fb435fbd97a9$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $70b3fb435fbd97a9$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($7KLhS)))('zero', {
    html: false
});
$70b3fb435fbd97a9$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $70b3fb435fbd97a9$export$267fd7ead7cc4561 {
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
    constructor(schema = (0, $ODlve.defaultSchema), tokenizer = $70b3fb435fbd97a9$var$md){
        this.markdownParser = void 0;
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $70b3fb435fbd97a9$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($70b3fb435fbd97a9$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $8iNK1.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $ldaVn.markdownItMedia));
        this.markdownParser = new (0, $4xvuZ.MarkdownParser)(schema, tokenizer, $70b3fb435fbd97a9$var$filterMdToPmSchemaMapping(schema, $70b3fb435fbd97a9$var$mdToPmMapping));
    }
}

});
parcelRegister("ldaVn", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $54a839e4270a9473$export$c8dcbd316b71f8cf);
function $54a839e4270a9473$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $54a839e4270a9473$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $54a839e4270a9473$var$createRule());
};

});




parcelRegister("8qpb0", function(module, exports) {

$parcel$export(module.exports, "CopySummaryButton", () => $305d9deffb86637c$export$7b7bdea6916b5e74);

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gwFzn = parcelRequire("gwFzn");

var $2MuFw = parcelRequire("2MuFw");

var $1qfLF = parcelRequire("1qfLF");

var $3gadb = parcelRequire("3gadb");

var $inPa6 = parcelRequire("inPa6");

var $fYQcF = parcelRequire("fYQcF");
const $305d9deffb86637c$var$i18n = (0, $2nPZH.defineMessages)({
    copyTooltip: {
        id: "quick-summary.quick-summary-header.copy-tooltip",
        defaultMessage: "Copy summary"
    },
    copiedTooltip: {
        id: "quick-summary.quick-summary-header.copied-tooltip",
        defaultMessage: "Copied!"
    }
});
const $305d9deffb86637c$export$7b7bdea6916b5e74 = ({ analyticsProperties: analyticsProperties, contentId: contentId, summaryText: summaryText, summaryId: summaryId })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [copyTooltipValue, setCopyTooltipValue] = (0, $gwFzn.useState)(intl.formatMessage($305d9deffb86637c$var$i18n.copyTooltip));
    const updateTooltip = (0, $gwFzn.useRef)();
    (0, $gwFzn.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        copyTooltipValue
    ]);
    // TODO: Copying summaries isn't great right now. Bullet points and emojis are omitted.
    // Will fix as part of https://hello.jira.atlassian.cloud/browse/CCSMART-1604
    const copySummary = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}CopySummaryButton`,
                attributes: {
                    contentId: contentId,
                    summaryId: summaryId,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        await navigator.clipboard.writeText(summaryText);
        setCopyTooltipValue(intl.formatMessage($305d9deffb86637c$var$i18n.copiedTooltip));
        setTimeout(()=>setCopyTooltipValue(intl.formatMessage($305d9deffb86637c$var$i18n.copyTooltip)), 1000);
        trackAIResultAction('copyButtonClicked');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                role: "status"
            }, copyTooltipValue);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
        label: intl.formatMessage($305d9deffb86637c$var$i18n.copyTooltip),
        spacing: "compact",
        onClick: copySummary,
        testId: "copy-summary-button"
    }));
};

});

parcelRegister("4UmYg", function(module, exports) {

$parcel$export(module.exports, "RefreshSummaryButton", () => $19b64ca5432253d6$export$5d65065bfdcb2326);

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $3gadb = parcelRequire("3gadb");

var $1qfLF = parcelRequire("1qfLF");

var $9pS9R = parcelRequire("9pS9R");

var $7VrTf = parcelRequire("7VrTf");
const $19b64ca5432253d6$var$i18n = (0, $2nPZH.defineMessages)({
    refreshTooltip: {
        id: "quick-summary.smarts-summary-header.refresh-tooltip",
        defaultMessage: "Generate new summary"
    }
});
const $19b64ca5432253d6$var$refreshContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'inline-flex'
});
const $19b64ca5432253d6$var$refreshHighlightIconStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.negative.075',
    right: 'space.negative.100'
});
const $19b64ca5432253d6$export$5d65065bfdcb2326 = ({ analyticsProperties: analyticsProperties, contentId: contentId, summaryId: summaryId, shouldHighlightRefresh: shouldHighlightRefresh = false, onRefreshClicked: onRefreshClicked })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleRefreshClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}RefreshButton`,
                attributes: {
                    contentId: contentId,
                    summaryId: summaryId,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        onRefreshClicked?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $19b64ca5432253d6$var$refreshContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: intl.formatMessage($19b64ca5432253d6$var$i18n.refreshTooltip),
        testId: "refresh-button-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleRefreshClick,
        testId: "refresh-summary-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))),
        label: intl.formatMessage($19b64ca5432253d6$var$i18n.refreshTooltip)
    })), shouldHighlightRefresh && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $19b64ca5432253d6$var$refreshHighlightIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7VrTf))), {
        label: "",
        color: "var(--ds-icon-brand, #0C66E4)",
        testId: "highlight-refresh-icon"
    })));
};

});
parcelRegister("9pS9R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6db0757f75190298$var$_react = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $6db0757f75190298$var$_baseNew = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6db0757f75190298$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6db0757f75190298$var$RefreshIcon = (props)=>/*#__PURE__*/ $6db0757f75190298$var$_react.default.createElement($6db0757f75190298$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$6db0757f75190298$var$RefreshIcon.displayName = 'RefreshIcon';
var $6db0757f75190298$var$_default = module.exports.default = $6db0757f75190298$var$RefreshIcon;

});

parcelRegister("7VrTf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73693506539a99d0ae3d26d395e92ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c537da57dc63fbb$var$_react = $5c537da57dc63fbb$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5c537da57dc63fbb$var$_baseNew = $5c537da57dc63fbb$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5c537da57dc63fbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for creating and adding an object as a secondary/tertiary action in a menu item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c537da57dc63fbb$var$AddIcon = (props)=>/*#__PURE__*/ $5c537da57dc63fbb$var$_react.default.createElement($5c537da57dc63fbb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$5c537da57dc63fbb$var$AddIcon.displayName = 'AddIcon';
var $5c537da57dc63fbb$var$_default = module.exports.default = $5c537da57dc63fbb$var$AddIcon;

});




//# sourceMappingURL=AISummaryFooter.465aa445.js.map
